import React from "react";

function WhiteLEhero() {
  return (
    <>
      <div
        className="banner-style-two-area bg-theme shadow theme text-light bg-cover text-center flex items-start"
        style={{
          backgroundImage:
            "url(assets/img/bg/white_label_crypto_exchange_image.jpg)",
          backgroundSize: "cover",
          backgroundPosition: "center",
          minHeight: "80vh",
        }}
      >
        <div className="container mx-auto px-4 pt-[270px] pb-20">
          <div className="max-w-3xl mx-auto">
            <h2 className="text-4xl md:text-6xl font-bold leading-tight mb-6">
              White Label Crypto Exchange Development
            </h2>

            <p className="text-lg md:text-xl text-gray-200 leading-relaxed">
              Get your white label crypto exchange developed by us <br />
              Lorem ipsum dolor, sit amet consectetur adipisicing elit. Qui
              impedit ipsum id rem commodi nobis quibusdam accusantium assumenda
              iste atque.
            </p>
          </div>
        </div>
      </div>
    </>
  );
}

export default WhiteLEhero;
